import React from 'react'
import { Link } from "react-router-dom";


const BlogDetails = () => {
  return (
    <>
      <div className="page-header dark-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="A Complete Guide to Solar Energy ..." style={{ perspective: 400 }}>
                  <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                    <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                      A Complete Guide to Solar Energy ...
                    </div>
                  </div>
                </h1>
                <div className="post-single-meta wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <ol className="breadcrumb">
                    <a to='/'> <li><i className="fa-regular fa-user" /> Home</li></a>
                    <li><i className="fa-regular fa-clock" /> Blog Details</li>
                  </ol>
                </div>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>

      <div className="page-single-post" style={{ marginTop: "-40px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Post Featured Image Start */}
              <div className="post-image">
                <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                  <img src="./assets/images/post-1.jpg" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                </figure>
              </div>
              {/* Post Featured Image Start */}
              {/* Post Single Content Start */}
              <div className="post-content">
                {/* Post Entry Start */}
                <div className="post-entry">

                  <h2 className="wow fadeInUp" data-wow-delay="0.8s" style={{ visibility: 'hidden', animationDelay: '0.8s', animationName: 'none' }}>Why Solar Energy Is the Future of Sustainable Power</h2>

                  <p className="wow fadeInUp" style={{ visibility: 'hidden', animationName: 'none' }}>Solar energy is emerging as one of the most promising solutions for meeting the world's growing energy needs while protecting the environment. With abundant sunlight available across many regions, solar power offers a clean, renewable, and increasingly accessible alternative to conventional energy sources.</p>
                  <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'hidden', animationDelay: '0.2s', animationName: 'none' }}>At Solar World Enterprises, we believe solar energy can play an important role in building a cleaner and more sustainable future. Solar panels convert sunlight into electricity without directly producing the air pollution associated with burning fossil fuels during operation. By adopting solar power, homes, businesses, farms, industries, and institutions can increase their use of renewable energy and reduce their dependence on conventional electricity sources.</p>
                  <blockquote className="wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'hidden', animationDelay: '0.4s', animationName: 'none' }}>
                    <p>Harness the power of the sun today and take a step towards a cleaner, smarter, and more sustainable tomorrow.</p>
                  </blockquote>

                  <h2 className="wow fadeInUp" data-wow-delay="0.8s" style={{ visibility: 'hidden', animationDelay: '0.8s', animationName: 'none' }}>Key Benefits of Solar Energy</h2>

                  <ul className="wow fadeInUp" data-wow-delay="1.2s" style={{ visibility: 'hidden', animationDelay: '1.2s', animationName: 'none' }}>
                    <li>Renewable Energy: Sunlight is a naturally replenished source of energy.</li>
                    <li>Clean Power Generation: Solar electricity helps support a cleaner energy mix.</li>
                    <li> Potential Cost Savings: Generating electricity from solar can help reduce dependence on grid power and manage long-term energy expenses.</li>
                    <li> Energy Independence: Solar systems can help customers generate a portion of their own electricity.</li>
                    <li> Low Operating Requirements: Once installed, solar PV systems generally require relatively limited routine maintenance.</li>
                    <li> Sustainable Development: Greater use of renewable energy can contribute to long-term environmental sustainability.</li>
                    <li> Versatile Applications: Solar solutions can be used for homes, businesses, industries, agriculture, institutions, and other applications.</li>
                  </ul>
                  <h2 className="wow fadeInUp" data-wow-delay="0.8s" style={{ visibility: 'hidden', animationDelay: '0.8s', animationName: 'none' }}>The Future of Clean Energy</h2>
                  <p className="wow fadeInUp" style={{ visibility: 'hidden', animationName: 'none' }}>As technology continues to improve and the demand for sustainable electricity grows, solar energy is becoming an increasingly important part of the global energy transition. Modern solar solutions can be designed to suit different energy requirements, property types, and operating conditions.</p>
                  <h2 className="wow fadeInUp" data-wow-delay="0.8s" style={{ visibility: 'hidden', animationDelay: '0.8s', animationName: 'none' }}>Our Commitment</h2>
                  <p className="wow fadeInUp" style={{ visibility: 'hidden', animationName: 'none' }}>Solar World Enterprises is committed to helping customers explore practical solar energy solutions through quality products, professional installation, customized system design, and dependable support.</p>
                </div>
                {/* Post Entry End */}
                {/* Post Tag Links Start */}
                <div className="post-tag-links">
                  <div className="row align-items-center">
                    <div className="col-lg-8">
                      {/* Post Tags Start */}
                      <div className="post-tags wow fadeInUp" data-wow-delay="0.5s" style={{ visibility: 'hidden', animationDelay: '0.5s', animationName: 'none' }}>
                        <span className="tag-links">
                          Tags:
                          <a to="#">Solar Energy</a>
                          <a to="#">Green Energy</a>
                          <a to="#">Sustainable Energy</a>
                        </span>
                      </div>
                      {/* Post Tags End */}
                    </div>
                    <div className="col-lg-4">
                      {/* Post Social Links Start */}
                      <div className="post-social-sharing wow fadeInUp" data-wow-delay="0.5s" style={{ visibility: 'hidden', animationDelay: '0.5s', animationName: 'none' }}>
                        <ul>
                          <li><Link target="blank" to="https://www.instagram.com/solar_westa?igsh=Zmg3eWh0ajhhYTlr"><i className="fa-brands fa-facebook-f" /></Link></li>
                          <li><Link target="blank" to="https://www.facebook.com/solarwesta"><i className="fa-brands fa-instagram" /></Link></li>
                        </ul>
                      </div>
                      {/* Post Social Links End */}
                    </div>
                  </div>
                </div>
                {/* Post Tag Links End */}
              </div>
              {/* Post Single Content End */}
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default BlogDetails